import { gql } from "@stadium/services/apollo-client";
import { ADDRESS_DETAILS } from "@stadium/checkout/src/graphql/fragments/address/details";

export const updateAddress = gql`
  mutation UpdateAddress($input: UpdateUserAddressInput!) @api(name: "users") {
    updateAddress(input: $input) {
      success
      errors
      address {
        ...AddressDetails
      }
    }
  }
  ${ADDRESS_DETAILS}
`;
